<template>
  <div ref="table" class="table-scroll__container" @scroll="handleScroll">
    <table class="table-scroll">
      <thead>
        <th v-for="header in thead" :key="header.title">
          <div
            :class="{ 'table-header__sort': header.sortBy }"
            @click="onChangeSort(header)"
          >
            {{ header.title }}
            <WIcon
              v-if="header.sortBy"
              :icon="getSortIcon(header)"
              size="medium"
            />
          </div>
        </th>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in rows"
          :key="row.id"
          :class="{ 'table-scroll--clickable': handleClick }"
          @click="onClick(row)"
        >
          <slot name="row" :row="row" :index="index"></slot>
        </tr>
        <template v-if="showPlaceholder">
          <HTablePlaceholder
            v-for="i in 5"
            :key="i"
            :columns-length="headers.length"
          />
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import { WIcon } from '@alice-health/wonderland-vue'

import HTablePlaceholder from './placeholder/HTablePlaceholder.vue'
export default {
  components: { WIcon, HTablePlaceholder },
  props: {
    headers: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      default: () => []
    },
    showPlaceholder: {
      type: Boolean
    },
    handleClick: {
      type: Function,
      default: undefined
    }
  },
  emits: ['onScrollEnd', 'onChangeSort'],
  data() {
    return {
      thead: []
    }
  },
  created() {
    this.thead = { ...this.headers }
  },
  methods: {
    handleScroll() {
      const table = this.$refs.table
      if (table.offsetHeight + table.scrollTop >= table.scrollHeight) {
        this.$emit('onScrollEnd')
      }
    },
    getSortIcon(header) {
      return header.order === 'desc' ? 'icArrowDown' : 'icArrowUp'
    },
    onChangeSort(header) {
      header.order = header.order === 'desc' ? 'asc' : 'desc'
      this.$emit('onChangeSort', header)
    },
    onClick(row) {
      if (this.handleClick) {
        this.handleClick(row)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.table-scroll__container {
  width: 100%;
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  border-radius: var(--gl-spacing-02);
  overflow-y: auto;
}
.table-scroll {
  width: 100%;

  thead {
    position: sticky;
    top: 0px;
    background-color: var(--gl-color-shades-white);
    z-index: 1;
    th {
      vertical-align: middle;
      background: var(--gl-color-shades-gray-00);
      padding: var(--gl-spacing-04) var(--gl-spacing-03);
      font-weight: var(--gl-font-weight-semibold);
      font-size: var(--gl-font-size-xxxs);
      line-height: var(--gl-line-height-xxxs);
      letter-spacing: var(--gl-letter-spacing-rule-02);
      color: var(--gl-color-shades-gray-60);
      .table-header__sort {
        display: flex;
        align-items: center;
        gap: var(--gl-spacing-02);
        cursor: pointer;
      }
    }
  }

  tr {
    border-top: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
    ::slotted(td) {
      padding: var(--gl-spacing-04) var(--gl-spacing-03);
      font-weight: var(--gl-font-weight-regular);
      font-size: var(--gl-font-size-xs);
      line-height: var(--gl-line-height-xxs);
      color: var(--gl-color-shades-gray-100);
      vertical-align: middle;
    }
  }

  tr:hover {
    background: var(--gl-color-shades-gray-10);
  }

  &--clickable {
    cursor: pointer;
  }
}
</style>
